import logo from "./logo.svg";
import "./App.css";

import AppPermissions from "./components/Permissions/AppPermissions";

import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";

import React, {
  useEffect,
  useState,
} from "react";

import SplashScreen from "./SplashScreen";



import Web from "./Web/Web";




/* =========================================================
   USER PAGES
========================================================= */

import ShowData from "./Users/ShowData";

import BroBizeeOnboarding from "./slider/BroBizeeOnboarding";
import Language from "./slider/Language";
import MobileNumber from "./slider/MobileNumber";
import Otp_Varification from "./slider/Otp-Varification";
import UserName from "./slider/UserName";
import UserAndPartner from "./slider/UserAndPartner";

import UserProfile from "./Users/UserProfile";
import Notification from "./Users/UsersHomePages/Notification";
import SerchingPartner from "./Users/UsersHomePages/SerchingPartner";
import ExtentProfile from "./Users/UsersHomePages/ExtentProfile";

import RequestAccept from "./Users/UsersHomePages/RequestAccept";
import ComingSoon from "./Users/UsersHomePages/ComingSoon";



import UserSearch from "./Users/Search/Search";
import UserBooking from "./Users/Booking/Booking";
import UserMedia from "./Users/Media/Media";
import UserWallet from "./Users/Wallet/Wallet";

import UpdateAddress from "./Users/UpdateAddress";


/* =========================================================
   PARTNER PAGES
========================================================= */

import PartnerHome from "./Partner/PartnerHome";
import NavigationPage from "./Partner/NavigationPage";

import PartnerBooking from "./Partner/Booking/PartnerBooking";

import PartnerPrivacyPolicy from "./Partner/NavSlider/PrivacyPolicy";
import PartnerEditProfile from "./Partner/NavSlider/PartnerEditProfile";


/* =========================================================
   USER NAVIGATION PAGES
========================================================= */

import EditProfile from "./Users/NavSlider/EditProfile";
import PrivacyPolicy from "./Users/NavSlider/PrivacyPolicy";
import ContactUs from "./Users/NavSlider/ContactUs";
import HelpSupport from "./Users/NavSlider/HelpSupport";


/* =========================================================
   PARTNER HOME PAGES
========================================================= */

import WorkUpload from "./Partner/PartnerHomePages/WorkUpload";
import CallingNoti from "./Partner/PartnerHomePages/CallingNoti";
import UserOtpVari from "./Partner/PartnerHomePages/UserOtpVari";

import PartnerWallet from "./Partner/Wallet/PartnerWallet";

import PaymentPage from "./Partner/PaymentPage";

import ShowPayment from "./Partner/ShowPayment";

/* =========================================================
   PARTNER LOGIN PAGES
========================================================= */

import PartnerLogin from "./Partner/LoginPages/PartnerLogin";
import PartnerLoginInfo from "./Partner/LoginPages/PartnerLoginInfo";
import SelectWorkPage from "./Partner/LoginPages/SelectWorkPage";
import Charges from "./Partner/LoginPages/Charges";

import IdProffVeri from "./Partner/LoginPages/IdProffVeri";
import BankVari from "./Partner/LoginPages/BankVari";
import VarifiedPage from "./Partner/LoginPages/VarifiedPage";


/* =========================================================
   STORAGE KEY
========================================================= */

const LAST_ROUTE_KEY = "brobizee_last_route";


/* =========================================================
   UUID VALIDATION
========================================================= */

const isValidDeviceUUID = (value) => {

  if (!value) {
    return false;
  }

  if (typeof value !== "string") {
    return false;
  }

  const uuid = value.trim();

  /*
    Standard UUID format.

    Example:

    578fead7-b6b6-4658-b969-41f26caf41c9
  */

  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return uuidRegex.test(uuid);
};


/* =========================================================
   FIND DEVICE UUID INSIDE ANY VALUE

   Handles:

   1. Direct string

      "578fead7-b6b6-4658-b969-41f26caf41c9"

   2. JSON string

      {
        "device_uuid":
        "578fead7-b6b6-4658-b969-41f26caf41c9"
      }

   3. Nested JSON

   4. Arrays
========================================================= */

const findDeviceUUIDInObject = (value) => {

  if (!value) {
    return null;
  }


  /* -------------------------------------------------------
     DIRECT STRING
  ------------------------------------------------------- */

  if (typeof value === "string") {

    const trimmedValue = value.trim();


    /*
      Direct UUID
    */

    if (isValidDeviceUUID(trimmedValue)) {

      return trimmedValue;

    }


    /*
      Try JSON parsing
    */

    try {

      const parsedValue =
        JSON.parse(trimmedValue);

      return findDeviceUUIDInObject(
        parsedValue
      );

    } catch (error) {

      return null;

    }

  }


  /* -------------------------------------------------------
     ARRAY
  ------------------------------------------------------- */

  if (Array.isArray(value)) {

    for (const item of value) {

      const result =
        findDeviceUUIDInObject(item);

      if (result) {

        return result;

      }

    }

    return null;

  }


  /* -------------------------------------------------------
     OBJECT
  ------------------------------------------------------- */

  if (typeof value === "object") {


    /*
      Common device UUID property names.
    */

    const possibleKeys = [

      "device_uuid",

      "deviceUuid",

      "deviceUUID",

      "device_id",

      "deviceId",

    ];


    /*
      First check direct UUID keys.
    */

    for (const key of possibleKeys) {

      if (
        Object.prototype.hasOwnProperty.call(
          value,
          key
        )
      ) {

        const result =
          findDeviceUUIDInObject(
            value[key]
          );

        if (result) {

          return result;

        }

      }

    }


    /*
      Search nested object values.
    */

    for (const key of Object.keys(value)) {

      const result =
        findDeviceUUIDInObject(
          value[key]
        );

      if (result) {

        return result;

      }

    }

  }


  return null;
};


/* =========================================================
   FIND USER ID INSIDE ANY VALUE
========================================================= */

const findUserIdInObject = (value) => {

  if (!value) {
    return null;
  }


  /* -------------------------------------------------------
     STRING
  ------------------------------------------------------- */

  if (typeof value === "string") {

    const trimmedValue =
      value.trim();


    /*
      If JSON string
    */

    try {

      const parsedValue =
        JSON.parse(trimmedValue);

      return findUserIdInObject(
        parsedValue
      );

    } catch (error) {

      /*
        If plain numeric user ID
      */

      if (/^\d+$/.test(trimmedValue)) {

        return trimmedValue;

      }

      return null;

    }

  }


  /* -------------------------------------------------------
     NUMBER
  ------------------------------------------------------- */

  if (typeof value === "number") {

    if (
      Number.isFinite(value) &&
      value > 0
    ) {

      return String(value);

    }

    return null;

  }


  /* -------------------------------------------------------
     ARRAY
  ------------------------------------------------------- */

  if (Array.isArray(value)) {

    for (const item of value) {

      const result =
        findUserIdInObject(item);

      if (result) {

        return result;

      }

    }

    return null;

  }


  /* -------------------------------------------------------
     OBJECT
  ------------------------------------------------------- */

  if (typeof value === "object") {

    const possibleKeys = [

      "user_id",

      "userId",

      "userid",

      "userID",

    ];


    /*
      Check common user ID keys first.
    */

    for (const key of possibleKeys) {

      if (
        Object.prototype.hasOwnProperty.call(
          value,
          key
        )
      ) {

        const currentValue =
          value[key];


        if (
          typeof currentValue === "number" &&
          currentValue > 0
        ) {

          return String(currentValue);

        }


        if (
          typeof currentValue === "string" &&
          /^\d+$/.test(
            currentValue.trim()
          )
        ) {

          return currentValue.trim();

        }

      }

    }


    /*
      Search nested objects.
    */

    for (const key of Object.keys(value)) {

      const result =
        findUserIdInObject(
          value[key]
        );

      if (result) {

        return result;

      }

    }

  }


  return null;
};


/* =========================================================
   GET DEVICE UUID FROM LOCAL STORAGE
========================================================= */

const getDeviceUUIDFromLocalStorage = () => {

  try {

    /*
      -----------------------------------------------------
      FIRST:
      Check common direct localStorage keys.
      -----------------------------------------------------
    */

    const directKeys = [

      "device_uuid",

      "deviceUuid",

      "deviceUUID",

      "device_id",

      "deviceId",

    ];


    for (const key of directKeys) {

      const value =
        localStorage.getItem(key);


      if (value) {

        const uuid =
          findDeviceUUIDInObject(value);


        if (uuid) {

          return uuid;

        }

      }

    }


    /*
      -----------------------------------------------------
      SECOND:
      Search ALL localStorage entries.

      This handles:

      userData = {
        user_id: 7,
        device_uuid: "578..."
      }

      partnerProfile = {
        deviceUuid: "578..."
      }

      etc.
      -----------------------------------------------------
    */

    for (
      let index = 0;
      index < localStorage.length;
      index++
    ) {

      const key =
        localStorage.key(index);


      if (!key) {
        continue;
      }


      const rawValue =
        localStorage.getItem(key);


      if (!rawValue) {
        continue;
      }


      const uuid =
        findDeviceUUIDInObject(
          rawValue
        );


      if (uuid) {

        return uuid;

      }

    }

  } catch (error) {

    console.error(
      "BroBizee: Error reading device_uuid:",
      error
    );

  }


  return null;
};


/* =========================================================
   GET USER ID FROM LOCAL STORAGE
========================================================= */

const getUserIdFromLocalStorage = () => {

  try {

    /*
      -----------------------------------------------------
      FIRST:
      Direct user ID keys.
      -----------------------------------------------------
    */

    const directKeys = [

      "user_id",

      "userId",

      "userid",

      "userID",

    ];


    for (const key of directKeys) {

      const value =
        localStorage.getItem(key);


      if (value) {

        const userId =
          findUserIdInObject(value);


        if (userId) {

          return userId;

        }

      }

    }


    /*
      -----------------------------------------------------
      SECOND:
      Search all localStorage JSON data.
      -----------------------------------------------------
    */

    for (
      let index = 0;
      index < localStorage.length;
      index++
    ) {

      const key =
        localStorage.key(index);


      if (!key) {
        continue;
      }


      const rawValue =
        localStorage.getItem(key);


      if (!rawValue) {
        continue;
      }


      /*
        Don't use route storage for user ID.
      */

      if (
        key === LAST_ROUTE_KEY
      ) {

        continue;

      }


      const userId =
        findUserIdInObject(
          rawValue
        );


      if (userId) {

        return userId;

      }

    }

  } catch (error) {

    console.error(
      "BroBizee: Error reading user_id:",
      error
    );

  }


  return null;
};


/* =========================================================
   GET SAVED LAST ROUTE
========================================================= */

const getSavedLastRoute = () => {

  try {

    const savedRoute =
      localStorage.getItem(
        LAST_ROUTE_KEY
      );


    if (!savedRoute) {

      return null;

    }


    /*
      Only internal application
      routes are allowed.
    */

    if (
      !savedRoute.startsWith("/")
    ) {

      return null;

    }


    /*
      Prevent:

      //
      http://
      https://
      javascript:
    */

    if (
      savedRoute.startsWith("//") ||
      savedRoute.includes("://") ||
      savedRoute.toLowerCase().includes(
        "javascript:"
      )
    ) {

      return null;

    }


    return savedRoute;

  } catch (error) {

    console.error(
      "BroBizee: Error reading last route:",
      error
    );

    return null;

  }

};


/* =========================================================
   CHECK SAVED ROUTE AGAINST CURRENT DEVICE UUID
========================================================= */

const isRouteForCurrentDevice = (
  route,
  deviceUUID
) => {

  if (
    !route ||
    !deviceUUID
  ) {

    return false;

  }


  /*
    Escape UUID for RegExp.
  */

  const escapedUUID =
    deviceUUID.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );


  /*
    Expected:

    /7/578fead7-b6b6-4658-b969-41f26caf41c9/userprofile

    /7/578fead7-b6b6-4658-b969-41f26caf41c9/partnerhome
  */

  const routeRegex =
    new RegExp(
      `^\\/[^\\/]+\\/${escapedUUID}(?:\\/.*)?$`,
      "i"
    );


  return routeRegex.test(route);

};


/* =========================================================
   PERSISTENT ROUTE CONTROLLER

   This component:

   1. Checks device_uuid
   2. Restores last route
   3. Saves every route change
========================================================= */

function PersistentRouteController() {

  const location =
    useLocation();


  const navigate =
    useNavigate();


  const [
    isCheckingDevice,
    setIsCheckingDevice
  ] = useState(true);


  const [
    deviceUUID,
    setDeviceUUID
  ] = useState(null);


  /* =======================================================
     STARTUP CHECK
  ====================================================== */

  useEffect(() => {

    const startApplication =
      () => {

        /*
          Get current device UUID.
        */

        const uuid =
          getDeviceUUIDFromLocalStorage();


        /*
          Get current user ID.
        */

        const userId =
          getUserIdFromLocalStorage();


        console.log(
          "===================================="
        );

        console.log(
          "BroBizee Startup"
        );

        console.log(
          "device_uuid:",
          uuid
        );

        console.log(
          "user_id:",
          userId
        );

        console.log(
          "current route:",
          location.pathname
        );

        console.log(
          "===================================="
        );


        setDeviceUUID(uuid);


        /* =================================================
           CASE 1:
           DEVICE UUID NOT FOUND
        ================================================= */

        if (!uuid) {

          console.log(
            "BroBizee: device_uuid NOT FOUND."
          );


          /*
            If some internal route was manually
            opened but no device exists,
            return to Web.
          */

          if (
            location.pathname !== "/" &&
            location.pathname !== ""
          ) {

            navigate(
              "/",
              {
                replace: true,
              }
            );

          }


          setIsCheckingDevice(false);

          return;

        }


        /* =================================================
           CASE 2:
           DEVICE UUID FOUND
        ================================================= */

        console.log(
          "BroBizee: device_uuid FOUND:",
          uuid
        );


        /*
          Read previous route.
        */

        const savedRoute =
          getSavedLastRoute();


        console.log(
          "BroBizee: saved last route:",
          savedRoute
        );


        /*
          -------------------------------------------------
          IF CURRENT PAGE IS ROOT
          -------------------------------------------------
        */

        if (
          location.pathname === "/" ||
          location.pathname === ""
        ) {


          /*
            Check whether saved route exists
            and belongs to current device.
          */

          if (
            savedRoute &&
            isRouteForCurrentDevice(
              savedRoute,
              uuid
            )
          ) {

            console.log(
              "BroBizee: Restoring previous route:",
              savedRoute
            );


            navigate(
              savedRoute,
              {
                replace: true,
              }
            );

          }

          /*
            If saved route does not exist,
            we leave "/" open.

            Therefore Web will open normally.
          */

          else {

            console.log(
              "BroBizee: No valid previous route found."
            );

          }

        }


        setIsCheckingDevice(false);

      };


    startApplication();


    /*
      Run startup check only once.
    */

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);


  /* =======================================================
     SAVE CURRENT ROUTE
  ====================================================== */

  useEffect(() => {

    /*
      Don't save root "/".

      Otherwise Web page would become
      the saved page.
    */

    if (
      !location.pathname ||
      location.pathname === "/"
    ) {

      return;

    }


    /*
      Device UUID must exist.
    */

    if (!deviceUUID) {

      return;

    }


    /*
      Complete route including:

      pathname
      search
      hash
    */

    const completeRoute =
      `${location.pathname}${location.search}${location.hash}`;


    try {

      localStorage.setItem(
        LAST_ROUTE_KEY,
        completeRoute
      );


      console.log(
        "BroBizee: Last route saved:",
        completeRoute
      );

    } catch (error) {

      console.error(
        "BroBizee: Unable to save last route:",
        error
      );

    }

  }, [
    location.pathname,
    location.search,
    location.hash,
    deviceUUID,
  ]);


  /* =======================================================
     WHILE STARTUP IS BEING CHECKED
  ====================================================== */

  if (isCheckingDevice) {

    return (
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#ffffff",
          color: "#222222",
          fontSize: "16px",
          fontFamily:
            "Arial, sans-serif",
        }}
      >
        Loading...
      </div>
    );

  }


  return null;

}


/* =========================================================
   ALL APPLICATION ROUTES

   Existing routes are preserved.
========================================================= */

function AppRoutes() {

  return (

    <>

      {/* =================================================
          PERSISTENT ROUTE CONTROLLER
      ================================================= */}

      <PersistentRouteController />


      {/* =================================================
          ROUTES
      ================================================= */}

      <Routes>

        {/* ===============================================
            SHOW DATA
        =============================================== */}

        <Route
          path="/showdata"
          element={<ShowData />}
        />


        {/* ===============================================
            MAIN WEB PAGE
        =============================================== */}

        <Route
          path="/"
          element={<Web />}
        />


        {/* ===============================================
            ONBOARDING
        =============================================== */}

        <Route
          path="/slider"
          element={<BroBizeeOnboarding />}
        />

        <Route
          path="/language"
          element={<Language />}
        />

        <Route
          path="/mobilenumber"
          element={<MobileNumber />}
        />

        <Route
          path="/otp-verification"
          element={<Otp_Varification />}
        />

        <Route
          path="/username"
          element={<UserName />}
        />


        {/* ===============================================
            MAIN PRIVACY POLICY
        =============================================== */}

        <Route
          path="/privacy-policy_main"
          element={<PrivacyPolicy />}
        />


        {/* ===============================================
            USER + PARTNER
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/userandpartner"
          element={<UserAndPartner />}
        />

        

        


        {/* ===============================================
            USER PROFILE
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/userprofile"
          element={<UserProfile />}
        />


// ⭐ ya jo bhi path ho tumhara

<Route
  path="/:userId/:deviceUuid/requestaccept"
  element={<RequestAccept />}
/>

<Route
  path="/:userId/:deviceUuid/Coming_soon"
  element={<ComingSoon />}
/>



        {/* ===============================================
            USER NOTIFICATION
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/notification"
          element={<Notification />}
        />


        {/* ===============================================
            SEARCH PARTNER
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/serching_partner"
          element={<SerchingPartner />}
        />

        <Route
  path="/:userId/:deviceUuid/partner/:partnerId"
  element={<ExtentProfile />}
/>





        {/* ===============================================
            USER EDIT PROFILE
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/edit_profile"
          element={<EditProfile />}
        />


        {/* ===============================================
            USER PRIVACY POLICY
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/privacy-policy"
          element={<PrivacyPolicy />}
        />


        {/* ===============================================
            PARTNER PRIVACY POLICY
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/partner_privacy-policy"
          element={<PartnerPrivacyPolicy />}
        />


        {/* ===============================================
            PARTNER EDIT PROFILE

            IMPORTANT:
            Your original route used ":uuid"
            so it is preserved exactly.
        =============================================== */}

        <Route
          path="/:userId/:uuid/partner_edit_Profile"
          element={<PartnerEditProfile />}
        />


        {/* ===============================================
            CONTACT US
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/contact-us"
          element={<ContactUs />}
        />


        {/* ===============================================
            HELP SUPPORT
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/help-support"
          element={<HelpSupport />}
        />


        {/* ===============================================
            USER SEARCH
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/search"
          element={<UserSearch />}
        />


        {/* ===============================================
            USER BOOKING
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/tasks"
          element={<UserBooking />}
        />


        {/* ===============================================
            USER MEDIA
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/media"
          element={<UserMedia />}
        />

        <Route
  path="/:userId/:uuid/payment"
  element={<PaymentPage />}
/>

 <Route
  path="/:userId/:uuid/show_payment"
  element={<ShowPayment />}
/>



        {/* ===============================================
            USER WALLET
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/wallet"
          element={<UserWallet />}
        />


        {/* =================================================
            PARTNER ROUTES
        ================================================= */}


        {/* ===============================================
            PARTNER HOME
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/partnerhome"
          element={<PartnerHome />}
        />

        
        {/* ===============================================
            WORK UPLOAD
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/workupload"
          element={<WorkUpload />}
        />


        {/* ===============================================
            CALLING NOTIFICATION
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/calling_noti"
          element={<CallingNoti />}
        />


        {/* ===============================================
            USER OTP VARIFICATION
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/user_otp_vari"
          element={<UserOtpVari />}
        />


        {/* ===============================================
            PARTNER WALLET
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/partner_wallet"
          element={<PartnerWallet />}
        />


        {/* ===============================================
            PARTNER BOOKING
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/partner_booking"
          element={<PartnerBooking />}
        />

<Route
  path="/:userId/:uuid/navigation_page"
  element={<NavigationPage />}
/>

        {/* ===============================================
            PARTNER LOGIN
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/partner_login"
          element={<PartnerLogin />}
        />


        {/* ===============================================
            PARTNER LOGIN INFO
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/partnerlogininfo"
          element={<PartnerLoginInfo />}
        />


        {/* ===============================================
            SELECT WORK PAGE
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/selectworkpage"
          element={<SelectWorkPage />}
        />
        <Route
          path="/:userId/:deviceUuid/charges_as_user"
          element={<Charges />}
        />

        


        {/* ===============================================
            ID PROOF VERIFICATION
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/idproffveri"
          element={<IdProffVeri />}
        />


        {/* ===============================================
            BANK VERIFICATION
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/bankvari"
          element={<BankVari />}
        />


        {/* ===============================================
            VERIFIED PAGE
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/varified_Page"
          element={<VarifiedPage />}
        />


        {/* ===============================================
            UPDATE ADDRESS
        =============================================== */}

        <Route
          path="/:userId/:deviceUuid/update_address"
          element={<UpdateAddress />}
        />

      </Routes>

    </>

  );

}


/* =========================================================
   HOME COMPONENT

   Preserved from your original code.
========================================================= */

function Home() {

  const navigate =
    useNavigate();


  return (

    <div className="App">

      <header className="App-header">

        <img
          src={logo}
          className="App-logo"
          alt="logo"
        />


        <p>
          Welcome to BroBizee
        </p>


        <button
          onClick={() =>
            navigate("/slider")
          }
          style={{
            padding: "12px 25px",
            fontSize: "18px",
            cursor: "pointer",
            borderRadius: "8px",
            border: "none",
          }}
        >
          Open BroBizee
        </button>

      </header>

    </div>

  );

}


/* =========================================================
   MAIN APP
========================================================= */

function App() {

  const [
    isLoading,
    setIsLoading
  ] = useState(true);


  /* =======================================================
     SPLASH SCREEN
  ====================================================== */

  useEffect(() => {

    const timer =
      setTimeout(() => {

        setIsLoading(false);

      }, 1500);


    return () =>
      clearTimeout(timer);

  }, []);


  /* =======================================================
     SHOW SPLASH
  ====================================================== */

  if (isLoading) {

    return (
      <SplashScreen />
    );

  }


  /* =======================================================
     APPLICATION
  ====================================================== */

  return (

    <BrowserRouter>

      {/* =================================================
          PERMISSIONS

          Preserved from your original code.

          Currently commented exactly as before.
      ================================================= */}

      {/* <AppPermissions /> */}


      <AppRoutes />

    </BrowserRouter>

  );

}


export default App;
